import React from 'react';
import Sidenavigation from '../layout/Sidenavigation';
import Topnavigation from '../layout/Topnavigation';
import Content from '../sections/Helpdesk-Cake-details/Content';
import { Helmet } from "react-helmet";

function HelpdeskVCakeDetails() {

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme">
            {/* title  */}
            <Helmet>
                <title>New Cake Details</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end  */}
            <main className="body-content">

                {/* Topnavigation start  */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content />
                {/* page content end  */}

            </main>

        </div>
    );
};

export default HelpdeskVCakeDetails;